import React, { useEffect, useRef } from "react";
import FooterColumn from "./FooterColumn";
import SocialMediaLink from "./SocialMediaLink";

import "./footer.css";
import { toAbsoluteUrl } from "../../assets/helpers/AssetHelpers";

import Slider from "react-slick";
import {
  socialMediaLinks,
  footerColumns,
  sliderData,
  footerData,
  importantInformation,
  marketScreenerShareMarket,
  marketScreenerIPO,
  FILTER_KEYS,
  getStocksListUrl,
  toolsLinks,
  footerDataLine,
  LETTERS,
  holidayLinks,
  getGlossaryUrl,
  LOWERCASE_FILTER_KEYS,
} from "./footerConstants";
const Footer = () => {
  const target = "_self";
  let sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2500,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    adaptiveHeight: true,
  };
  useEffect(() => {
    const img = new Image();
    img.src = process.env.PUBLIC_URL + "footer-images/footer-logo.webp";
    img.onload = () => {
      const footerLogo = document.querySelector("#footer-logo") as HTMLImageElement | null;
      if (footerLogo) {
        footerLogo.src = img.src;
      }
    };
  }, []);
  return (
    <>
      <section style={{ background: "#F8F8F8" }}>
        {/* <footer className="bd-footer "> */}
        <div className="container " style={{ overflowX: "hidden" }}>
          <div className="row">
            <div className="col my-5">
              <div className="row">
                <div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">
                  <div className="footer-main-grid">
                    <div className="mb-3"></div>
                    <div>
                      <div className="row">
                        <a
                          className="d-inline-flex align-items-center mb-2 text-body-emphasis text-decoration-none"
                          href="/"
                          aria-label="Bootstrap"
                        >
                          <img
                            src={toAbsoluteUrl("navbar-section/jainam.webp")}
                            alt=""
                            className="img-fluid"
                          />
                        </a>
                      </div>
                      <div className="footer-grid">
                        <div className="custom-footer-width">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="color28 in_med fs-16 my-3">
                                Jainam House, Plot No. 42, Near Shardayatan School, Piplod, Surat,
                                Gujarat, India, 395007
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="color28 lh-24 fs-16 in_semi">FOLLOW US ON</div>
                              <ul className="d-flex justify-content-lg-between list-unstyled mt-3 my-3">
                                {socialMediaLinks.map((link, index) => (
                                  <SocialMediaLink
                                    key={index}
                                    href={link.href}
                                    src={link.src}
                                    alt={link.alt}
                                  />
                                ))}
                              </ul>
                              <div className="row my-lg-0 my-4">
                                <div className="col-md-6 col-4">
                                  <a href="https://play.google.com/store/apps/details?id=com.codifi.jainam&hl=en_US&pli=1">
                                    <img
                                      className="w-100"
                                      src={toAbsoluteUrl("footer-images/googlePlay.svg")}
                                      alt="Google Play"
                                    />
                                  </a>
                                </div>
                                <div className="col-md-6 col-4">
                                  <a href="https://apps.apple.com/au/app/jainam-lite/id6471670339">
                                    <img
                                      className="w-100"
                                      src={toAbsoluteUrl("footer-images/appStore.svg")}
                                      alt="App Store"
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {footerColumns.map((column, index) => (
                          <FooterColumn
                            key={index}
                            title={column.title}
                            links={column.links}
                            subSections={column.subSections}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="footer-bg">
                    <div className="mt-lg-4 mb-1 footer-flat-layout">
                      <div className="row">
                        {/* Row 5: Calculators */}
                        <div className="row mb-3">
                          <div className="col-12 col-md-3 col-lg-2 mb-2 mb-md-0">
                            <div className="fs-14 in_semi color28 text-uppercase">Calculators</div>
                          </div>

                          <div className="col-12 col-md-9 col-lg-10">
                            <ul className="list-inline mb-0">
                              {toolsLinks.map((link, index) => (
                                <li key={index} className="list-inline-item me-0">
                                  <a
                                    href={link.href}
                                    target={target}
                                    className={`decoration fs-12 in_reg color28 footer-link ${index < toolsLinks.length - 1 ? "footer-link-pipe" : ""}`}
                                  >
                                    {link.text}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        {/* Row 2: IPO */}
                        <div className="row mb-3">
                          <div className="col-12 col-md-3 col-lg-2 mb-2 mb-md-0">
                            <div className="fs-14 in_semi color28 text-uppercase">IPO</div>
                          </div>

                          <div className="col-12 col-md-9 col-lg-10">
                            <ul className="list-inline mb-0">
                              {marketScreenerIPO.map((link, index) => (
                                <li key={index} className="list-inline-item me-0">
                                  <a
                                    href={link.href}
                                    target={target}
                                    className={`decoration fs-12 in_reg color28 footer-link ${index < marketScreenerIPO.length - 1 ? "footer-link-pipe" : ""}`}
                                  >
                                    {link.text}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        {/* Row 3: Stock Directory */}
                        <div className="row mb-3">
                          <div className="col-12 col-md-3 col-lg-2 mb-2 mb-md-0">
                            <div className="fs-14 in_semi color28 text-uppercase">
                              Stock Directory
                            </div>
                          </div>

                          <div className="col-12 col-md-9 col-lg-10">
                            <ul className="list-inline mb-0">
                              {LOWERCASE_FILTER_KEYS.map((key, index) => (
                                <li key={index} className="list-inline-item me-0">
                                  <a
                                    href={getStocksListUrl(key)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`decoration fs-12 in_reg color28 footer-link ${index < LOWERCASE_FILTER_KEYS.length - 1 ? "footer-link-pipe" : ""}`}
                                  >
                                    {key.toLocaleUpperCase()}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-12 col-md-3 col-lg-2 mb-2 mb-md-0">
                            <div className="fs-14 in_semi color28 text-uppercase">Glossary</div>
                          </div>

                          <div className="col-12 col-md-9 col-lg-10">
                            <ul className="list-inline mb-0">
                              {LETTERS.map((key, index) => (
                                <li key={index} className="list-inline-item me-0">
                                  <a
                                    href={getGlossaryUrl(key)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`decoration fs-12 in_reg color28 footer-link ${index < LETTERS.length - 1 ? "footer-link-pipe" : ""}`}
                                  >
                                    {key}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-12 col-md-3 col-lg-2 mb-2 mb-md-0">
                            <div className="fs-14 in_semi color28 text-uppercase">
                              Share Market Today
                            </div>
                          </div>
                          <div className="col-12 col-md-9 col-lg-10">
                            <ul className="list-inline mb-0">
                              {marketScreenerShareMarket.map((link, index) => (
                                <li key={index} className="list-inline-item me-0">
                                  <a
                                    href={link.href}
                                    target={target}
                                    className={`decoration fs-12 in_reg color28 footer-link ${index < marketScreenerShareMarket.length - 1 ? "footer-link-pipe" : ""}`}
                                  >
                                    {link.text}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-12 col-md-3 col-lg-2 mb-2 mb-md-0">
                            <div className="fs-14 in_semi color28 text-uppercase">
                              Holiday Calendar
                            </div>
                          </div>
                          <div className="col-12 col-md-9 col-lg-10">
                            <ul className="list-inline mb-0">
                              {holidayLinks.map((link, index) => (
                                <li key={index} className="list-inline-item me-0">
                                  <a
                                    href={link.href}
                                    target={target}
                                    className={`decoration fs-12 in_reg color28 footer-link ${index < marketScreenerShareMarket.length - 1 ? "footer-link-pipe" : ""}`}
                                  >
                                    {link.text}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div>
                      <div className="footer-container">
                        {footerDataLine.map((item, index) => (
                          <div key={index} className="footer-desc mb-3">
                            {item.content}
                          </div>
                        ))}
                      </div>
                      <div className="slider-container">
                        <Slider ref={(slider) => (slider = slider)} {...settings}>
                          {sliderData.map((item, index) => (
                            <div key={index}>
                              <div className="in_bold fs-18 lh-24 color28">{item.title}</div>
                              <div className="footer-desc my-3">{item.description}</div>
                            </div>
                          ))}
                        </Slider>
                      </div>

                      <div className="footer-container">
                        {footerData.map((item, index) => (
                          <div
                            key={index}
                            className="footer-desc"
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </footer> */}
      </section>
    </>
  );
};

export default Footer;
